module.exports = __webpack_public_path__ + "static/media/ug2.fb140b05.png";